var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsefile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1168 0H8.96244C8.01097 0 7.20587 0.673797 6.9863 1.64706L2.00937 27.0267C1.93618 27.5508 2.30213 28 2.74127 28H36.7747C37.4334 28 38.0189 27.4759 38.0921 26.8021L40.9465 2.32086C41.2393 1.04813 40.2878 0 39.1168 0Z",
    fill: "#3eb8aa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M32.986 5H21.8698C21.2073 5 20.6183 5.37705 20.2503 5.90492L18.9988 7.94098C18.9988 8.01639 18.9251 8.01639 18.8515 8.01639H1.47793C0.594523 8.01639 -0.0680295 8.77049 0.00558744 9.6L1.62516 26.8689C1.69878 27.4721 2.2141 28 2.80303 28H37.1085C37.6239 28 38.0656 27.4721 37.9919 26.9443L34.9 6.65902C34.7528 5.7541 33.943 5 32.986 5Z",
    fill: "#3EB8AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsefile);
export default __webpack_public_path__ + "static/media/browsefile.8237c994be6c763da83a8119ec420f34.svg";
export { ForwardRef as ReactComponent };